import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import SummaryAnnualLeave from '@/types/table/summaryAnnualLeave';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface SummaryAnnualLeaveData extends SummaryAnnualLeave {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class SummaryAnnualLeaveController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryAnnualLeaveData>>(API_CONTEXT + '/app/summaryAnnualLeave/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<SummaryAnnualLeaveData>(API_CONTEXT + '/app/summaryAnnualLeave/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/summaryAnnualLeave/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/summaryAnnualLeave/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/summaryAnnualLeave/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryAnnualLeave/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryAnnualLeave/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryAnnualLeave/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryAnnualLeave/deleteBatch', params, httpOptions);
  }
  static salaryExchange(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryAnnualLeave/salaryExchange', params, httpOptions);
  }
}
